/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my text sent anywhere?`)
};

const es_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se envía mi texto a algún lugar?`)
};

const de_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Text irgendwohin gesendet?`)
};

const nl_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn tekst ergens verzonden?`)
};

const fr_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon texte est-il envoyé quelque part?`)
};

const it_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio testo viene inviato da qualche parte?`)
};

const pt_br2_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é enviado para algum lugar?`)
};

const pt_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu texto é enviado para algum lugar?`)
};

const ja_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストはどこかに送信されていますか?`)
};

const zh_tb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文本会被发送到其他地方吗?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq3_q", locale)
	if (locale === "en") return en_tb_faq3_q(inputs)
	if (locale === "es") return es_tb_faq3_q(inputs)
	if (locale === "de") return de_tb_faq3_q(inputs)
	if (locale === "nl") return nl_tb_faq3_q(inputs)
	if (locale === "fr") return fr_tb_faq3_q(inputs)
	if (locale === "it") return it_tb_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq3_q(inputs)
	if (locale === "pt") return pt_tb_faq3_q(inputs)
	if (locale === "ja") return ja_tb_faq3_q(inputs)
	return zh_tb_faq3_q(inputs)
};